import { useContext } from "react";
import { EditContext } from "./EditProvider";
import { css } from "@emotion/css";
import { blue, grey } from "@mui/material/colors";
import { useDragDrop } from "./DragDrop";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function TableViewEditableCell(props) {
    var _ctx$onRange$lastValu, _modified$current, _ctx$cellCustomize, _ctx$cellCustomize$ba;
    const ctx = useContext(EditContext);
    const { index, rangeSelected, autoGrow, modified, config } = props;
    const adjustedIndex = index + props.indexOffset;
    const isRangeSelected = !!rangeSelected && rangeSelected.min <= adjustedIndex && rangeSelected.max >= adjustedIndex;
    const isRightOfRange = isRangeSelected && rangeSelected && adjustedIndex === rangeSelected.max;
    const isTopOfRange = isRangeSelected && ((_ctx$onRange$lastValu = ctx.onRange.lastValue) === null || _ctx$onRange$lastValu === void 0 ? void 0 : _ctx$onRange$lastValu.ids.indexOf(props.value.id)) === 0;
    const drag = useDragDrop({ column: props.column, value: props.value });
    const modifiedItem = (_modified$current = modified.current) === null || _modified$current === void 0 ? void 0 : _modified$current.findLast(m => m.index === index);
    return /*#__PURE__*/ _jsx("div", { onDragOver: drag.onDragOver, onDragEnter: drag.onDragEnter, onDragLeave: drag.onDragLeave, onDrop: drag.onDrop, onClick: e => {
            var _document$getSelectio;
            e.stopPropagation(); // sometimes the text get's selected
            (_document$getSelectio = document.getSelection()) === null || _document$getSelectio === void 0 ? void 0 : _document$getSelectio.removeAllRanges();
            if (e.shiftKey && (ctx.onSelect.lastValue || ctx.onRange.lastValue)) {
                let lastId = 0;
                let lastIndex = 0;
                const range = ctx.onRange.lastValue;
                const select = ctx.onSelect.lastValue;
                if (range) {
                    lastId = range.fromId;
                    lastIndex = range.fromIndex;
                }
                else if (select) {
                    lastId = select.id;
                    lastIndex = select.index;
                    ctx.onSelect.emit(null);
                }
                let ids = [];
                let record = false;
                if (lastId === props.value.id) {
                    ids.push(lastId);
                }
                else {
                    var _props$dataRef$curren;
                    (_props$dataRef$curren = props.dataRef.current) === null || _props$dataRef$curren === void 0 ? void 0 : _props$dataRef$curren.map(row => { if (row.id === lastId || row.id === props.value.id) {
                        if (!record) {
                            record = true;
                        }
                        else {
                            ids.push(row.id);
                            record = false;
                        }
                    } if (record) {
                        ids.push(row.id);
                    } return null; });
                }
                ctx.onRange.emit({ fromId: lastId, fromIndex: lastIndex, toId: props.value.id, toIndex: index + props.indexOffset, ids: ids });
                return;
            }
            ctx.onRange.emit(null);
            ctx.onSelect.emit({ id: props.value.id, index: index + props.indexOffset, value: props.value, editing: false });
        }, className: editCell + " " + (isRangeSelected ? rangeSelectedCell : standardCell), "data-col": props.column.name, style: { width: autoGrow ? undefined : config.width, flex: autoGrow ? 1 : undefined, minWidth: config.width, textAlign: props.column.alignRight ? "right" : undefined, borderRight: props.isLast ? "none" : isRangeSelected && !isRightOfRange ? "1px solid transparent" : undefined, borderTop: isRangeSelected && !isTopOfRange ? "1px solid transparent" : undefined, backgroundColor: !!modifiedItem ? grey["200"] : drag.isDraggingOver ? blue["300"] : drag.isLighthouse ? blue["50"] : ((_ctx$cellCustomize = ctx.cellCustomize) === null || _ctx$cellCustomize === void 0 ? void 0 : (_ctx$cellCustomize$ba = _ctx$cellCustomize.backgroundColor) === null || _ctx$cellCustomize$ba === void 0 ? void 0 : _ctx$cellCustomize$ba.call(_ctx$cellCustomize, props.value, props.column)) || undefined, whiteSpace: "pre-wrap" }, children: props.column.render((modifiedItem === null || modifiedItem === void 0 ? void 0 : modifiedItem.value) || props.value, props.column) || /*#__PURE__*/ _jsx(_Fragment, { children: "\xA0" }) });
}
const rangeSelectedCell = css({ border: "1px solid " + blue["600"] });
const standardCell = css({ border: "1px solid transparent", borderRight: "1px solid " + grey["300"] });
const editCell = css({ position: "relative", paddingLeft: 4, paddingRight: 4, paddingBottom: 3, paddingTop: 3, fontSize: "0.8rem", cursor: "pointer", lineHeight: "1em", wordBreak: "break-all", "&:hover": { border: "1px solid " + blue["600"] } });
